module.exports = __webpack_public_path__ + "static/media/divide.09f15129.svg";